import { siQueryKeyFactory } from "app/pages/sales-intelligence/query/queryKeyFactory";
import { accountSettingKeyMap } from "app/pages/sales-intelligence/services/api/account-settings/types";

import { isAccountOptedInIndustryTaxonomy } from "../../utils/accountIndustryTaxonomyOptIn";

import type { IIndustryQueryClient, IIndustryQueryClientDeps } from "./types";

const optInQueryKey = () => siQueryKeyFactory.accountSetting(accountSettingKeyMap.accountOptedInIndustryTaxonomy);

export const createIndustryQueryClient = ({ queryClient }: IIndustryQueryClientDeps): IIndustryQueryClient => ({
    /**
     * Written through rather than invalidated: everything gated on the opt-in has to see the new value
     * within the same turn as enrolling — including the demo exit, which decides from it whether to
     * restore a legacy filter that would now have no card to render in.
     *
     * The setting is cached as the raw `string | null` the endpoint returns, so both sides mirror the
     * coercion in `useIsIndustryTaxonomyOptedIn` instead of storing a boolean.
     */
    markTaxonomyOptedIn: (): void => {
        queryClient.setQueryData(optInQueryKey(), "true");
    },

    readIsTaxonomyOptedIn: (): boolean =>
        isAccountOptedInIndustryTaxonomy(queryClient.getQueryData<string | null>(optInQueryKey())),
});
